'use strict'

var API = 'https://widget-api.gerencert.app'

var THEME_PRIMARY_COLOR = '#1d78d7'
var THEME_SECUNDARY_COLOR = '#3d3d3d'

var STATES = ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO']

var CARD_SECRET = '9853123412488172'

angular.module('app')
  .constant('API', API)
  .constant('STATES', STATES)
  .constant('THEME_PRIMARY_COLOR', THEME_PRIMARY_COLOR)
  .constant('THEME_SECUNDARY_COLOR', THEME_SECUNDARY_COLOR)
  .constant('CARD_SECRET', CARD_SECRET)



//////////////////
// WEBPACK FOOTER
// ./constants/constant.js
// module id = 87
// module chunks = 0